import { useEffect, useState } from "react";
import { AcademyService } from "../../../Component/Api/Academy/AcademyService";
import { WebinarSection } from "../../../Component/Model/Dto/Academy";
import { ceil } from 'lodash';
import { SimplePagination } from "../../../Component/Common/Pagination/simplePagination";
import { Accordion, AccordionDetails, AccordionSummary, Grid} from '@mui/material';
import { SkeletonLoading } from "../../../Component/Common/SkeletonLoading/SkeletonLoading";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { WebinarSectionDataTable } from "./WebinarsSectionDataTable";
import FolderOffIcon from '@mui/icons-material/FolderOff';

export const WebinarsPage = () =>{

    const [webinarSectionData, setWebinarSectionData] = useState<WebinarSection.DtoIn[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchSections = async () => {
        setIsLoading(true);
        try {
          let response = await AcademyService.SearchWebinarSections();
          setWebinarSectionData(response.data);
        }
        catch (error) {
          console.error("Unable to retrieve Training Webinar search results");
        }
        finally {
          setIsLoading(false);
        }
      }

      useEffect(() => {
        fetchSections();
      }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (webinarSectionData.length > 0) {
        return (
          <>
          <MDBox mt={3}>
                <Grid container mt={2} mb={2}>
                    <Grid item xs={12} >
                        <MDBox style={{borderRadius:"0.75rem"}}>
                            {
                                webinarSectionData.map((section, index) => {
                                    return(
                                          <Accordion defaultExpanded={false} square={false} key={index}>
                                              <AccordionSummary
                                                  expandIcon={<ExpandMoreIcon />}    
                                              >
                                                  <Grid container>
                                                  <Grid item xs={11}>
                                                      <MDTypography variant="body" fontWeight="bold">{section.sectionName}</MDTypography>
                                                  </Grid>
                                                  <Grid item xs={1}>
                                                      <MDTypography variant="body2" >{section.sectionItemsCount + " entries"}</MDTypography>         
                                                  </Grid>
                                                  </Grid>
                                              </AccordionSummary>
                                              <AccordionDetails style={{padding:"0px"}}>
                                                  <WebinarSectionDataTable sectionId={section.id}></WebinarSectionDataTable>
                                              </AccordionDetails>
                                          </Accordion>
                                    )
                                })
                            }
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
          </>
        )
      }
      else {
        if (isLoading) {
          return <SkeletonLoading formLoading FieldAmount={6} />
        }
        else {
          return (
            <MDBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" marginTop="20px">
              <FolderOffIcon sx={{ height: '128px', width: '128px', color: '#999' }} />
              <MDTypography variant="h5" color="#999" marginTop="10px">
                No Training Webinars to Show
              </MDTypography>
            </MDBox>
          )
        }
      }
}